// source: types/market_premium.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var types_time_data_pb = require('../types/time_data_pb.js');
goog.object.extend(proto, types_time_data_pb);
goog.exportSymbol('proto.types.EnergySource', null, global);
goog.exportSymbol('proto.types.MarketPremiumConfigs', null, global);
goog.exportSymbol('proto.types.MarketPremiumInfo', null, global);
goog.exportSymbol('proto.types.MarketValueType', null, global);
goog.exportSymbol('proto.types.MarketValueType.ApplicationPeriodCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.MarketValueType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.types.MarketValueType.oneofGroups_);
};
goog.inherits(proto.types.MarketValueType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.MarketValueType.displayName = 'proto.types.MarketValueType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.MarketPremiumInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.MarketPremiumInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.MarketPremiumInfo.displayName = 'proto.types.MarketPremiumInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.MarketPremiumConfigs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.MarketPremiumConfigs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.MarketPremiumConfigs.displayName = 'proto.types.MarketPremiumConfigs';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.types.MarketValueType.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.types.MarketValueType.ApplicationPeriodCase = {
  APPLICATION_PERIOD_NOT_SET: 0,
  MONTH: 1,
  YEAR: 2
};

/**
 * @return {proto.types.MarketValueType.ApplicationPeriodCase}
 */
proto.types.MarketValueType.prototype.getApplicationPeriodCase = function() {
  return /** @type {proto.types.MarketValueType.ApplicationPeriodCase} */(jspb.Message.computeOneofCase(this, proto.types.MarketValueType.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.MarketValueType.prototype.toObject = function(opt_includeInstance) {
  return proto.types.MarketValueType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.MarketValueType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.MarketValueType.toObject = function(includeInstance, msg) {
  var f, obj = {
    month: (f = msg.getMonth()) && types_time_data_pb.MonthYear.toObject(includeInstance, f),
    year: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.MarketValueType}
 */
proto.types.MarketValueType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.MarketValueType;
  return proto.types.MarketValueType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.MarketValueType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.MarketValueType}
 */
proto.types.MarketValueType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new types_time_data_pb.MonthYear;
      reader.readMessage(value,types_time_data_pb.MonthYear.deserializeBinaryFromReader);
      msg.setMonth(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.MarketValueType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.MarketValueType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.MarketValueType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.MarketValueType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonth();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      types_time_data_pb.MonthYear.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional MonthYear month = 1;
 * @return {?proto.types.MonthYear}
 */
proto.types.MarketValueType.prototype.getMonth = function() {
  return /** @type{?proto.types.MonthYear} */ (
    jspb.Message.getWrapperField(this, types_time_data_pb.MonthYear, 1));
};


/**
 * @param {?proto.types.MonthYear|undefined} value
 * @return {!proto.types.MarketValueType} returns this
*/
proto.types.MarketValueType.prototype.setMonth = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.types.MarketValueType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.types.MarketValueType} returns this
 */
proto.types.MarketValueType.prototype.clearMonth = function() {
  return this.setMonth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.MarketValueType.prototype.hasMonth = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 year = 2;
 * @return {number}
 */
proto.types.MarketValueType.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.types.MarketValueType} returns this
 */
proto.types.MarketValueType.prototype.setYear = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.types.MarketValueType.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.MarketValueType} returns this
 */
proto.types.MarketValueType.prototype.clearYear = function() {
  return jspb.Message.setOneofField(this, 2, proto.types.MarketValueType.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.MarketValueType.prototype.hasYear = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.MarketPremiumInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.types.MarketPremiumInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.MarketPremiumInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.MarketPremiumInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    unit: jspb.Message.getFieldWithDefault(msg, 3, ""),
    valueFormatted: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.MarketPremiumInfo}
 */
proto.types.MarketPremiumInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.MarketPremiumInfo;
  return proto.types.MarketPremiumInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.MarketPremiumInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.MarketPremiumInfo}
 */
proto.types.MarketPremiumInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValueFormatted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.MarketPremiumInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.MarketPremiumInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.MarketPremiumInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.MarketPremiumInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValueFormatted();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.types.MarketPremiumInfo.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.MarketPremiumInfo} returns this
 */
proto.types.MarketPremiumInfo.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.types.MarketPremiumInfo.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.types.MarketPremiumInfo} returns this
 */
proto.types.MarketPremiumInfo.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string unit = 3;
 * @return {string}
 */
proto.types.MarketPremiumInfo.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.MarketPremiumInfo} returns this
 */
proto.types.MarketPremiumInfo.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string value_formatted = 4;
 * @return {string}
 */
proto.types.MarketPremiumInfo.prototype.getValueFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.MarketPremiumInfo} returns this
 */
proto.types.MarketPremiumInfo.prototype.setValueFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.MarketPremiumConfigs.prototype.toObject = function(opt_includeInstance) {
  return proto.types.MarketPremiumConfigs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.MarketPremiumConfigs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.MarketPremiumConfigs.toObject = function(includeInstance, msg) {
  var f, obj = {
    useYearlyMarketValue: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    energySource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    referenceValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    numConsecutiveNegativePrices: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.MarketPremiumConfigs}
 */
proto.types.MarketPremiumConfigs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.MarketPremiumConfigs;
  return proto.types.MarketPremiumConfigs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.MarketPremiumConfigs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.MarketPremiumConfigs}
 */
proto.types.MarketPremiumConfigs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseYearlyMarketValue(value);
      break;
    case 2:
      var value = /** @type {!proto.types.EnergySource} */ (reader.readEnum());
      msg.setEnergySource(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferenceValue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumConsecutiveNegativePrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.MarketPremiumConfigs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.MarketPremiumConfigs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.MarketPremiumConfigs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.MarketPremiumConfigs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUseYearlyMarketValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {!proto.types.EnergySource} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional bool use_yearly_market_value = 1;
 * @return {boolean}
 */
proto.types.MarketPremiumConfigs.prototype.getUseYearlyMarketValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.types.MarketPremiumConfigs} returns this
 */
proto.types.MarketPremiumConfigs.prototype.setUseYearlyMarketValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional EnergySource energy_source = 2;
 * @return {!proto.types.EnergySource}
 */
proto.types.MarketPremiumConfigs.prototype.getEnergySource = function() {
  return /** @type {!proto.types.EnergySource} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.types.EnergySource} value
 * @return {!proto.types.MarketPremiumConfigs} returns this
 */
proto.types.MarketPremiumConfigs.prototype.setEnergySource = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.MarketPremiumConfigs} returns this
 */
proto.types.MarketPremiumConfigs.prototype.clearEnergySource = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.MarketPremiumConfigs.prototype.hasEnergySource = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double reference_value = 3;
 * @return {number}
 */
proto.types.MarketPremiumConfigs.prototype.getReferenceValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.types.MarketPremiumConfigs} returns this
 */
proto.types.MarketPremiumConfigs.prototype.setReferenceValue = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.MarketPremiumConfigs} returns this
 */
proto.types.MarketPremiumConfigs.prototype.clearReferenceValue = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.MarketPremiumConfigs.prototype.hasReferenceValue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 num_consecutive_negative_prices = 4;
 * @return {number}
 */
proto.types.MarketPremiumConfigs.prototype.getNumConsecutiveNegativePrices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.types.MarketPremiumConfigs} returns this
 */
proto.types.MarketPremiumConfigs.prototype.setNumConsecutiveNegativePrices = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.MarketPremiumConfigs} returns this
 */
proto.types.MarketPremiumConfigs.prototype.clearNumConsecutiveNegativePrices = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.MarketPremiumConfigs.prototype.hasNumConsecutiveNegativePrices = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * @enum {number}
 */
proto.types.EnergySource = {
  HYDROPOWER: 0,
  LANDFILLGAS: 1,
  SEWAGEGAS: 2,
  MINEGAS: 3,
  BIOMASS: 4,
  GEOTHERMAL: 5,
  WINDOFFSHORE: 6,
  WINDONSHORE: 7,
  SOLAR: 8
};

goog.object.extend(exports, proto.types);
